import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
	const swiperContainer = document.querySelector('.swiper');

	if (!swiperContainer) {
		return;
	}

	const nextEl = document.querySelector('.swiper-button-next');
	const prevEl = document.querySelector('.swiper-button-prev');

	const carouselSpeed = swiperContainer.dataset.carouselSpeed;

	new Swiper('.swiper', {
		speed: parseInt(carouselSpeed),
		loop: true,
		slidesPerView: 1,
		spaceBetween: 20,

		modules: [Autoplay, Navigation],

		autoplay: {
			delay: parseInt(carouselSpeed),
			pauseOnMouseEnter: true,
			waitForTransition: true,
		},

		navigation: {
			nextEl,
			prevEl,
		},

		breakpoints: {
            320: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            480: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            640: {
                slidesPerView: 4,
                spaceBetween: 40,
            },
            880: {
                slidesPerView: 5,
                spaceBetween: 40,
            },
            1120: {
                slidesPerView: 6,
                spaceBetween: 40,
            }
        },
	  });
});
